const translations = {
  "en": {
    "%{var0}% OFF": "%{var0}% OFF",
    "Annual": "Annual",
    "Best Value": "Best Value",
    "Lifetime": "Lifetime",
    "Monthly": "Monthly",
    "Weekly": "Weekly"
  },
  "zh-tw": {
    "%{var0}% OFF": "%{var0}% 折扣",
    "Annual": "年度",
    "Best Value": "最佳價值",
    "Lifetime": "終身",
    "Monthly": "每月",
    "Weekly": "每週"
  }
};

export default translations;
